import React from 'react';
import '../../styles/Components/languagetoggler.css'

const LanguageToggle = ({ toggleLanguage, currentLanguage }) => {
    const isArabic = currentLanguage === "ar";
    
    const handleToggle = () => {
      toggleLanguage(isArabic ? "en" : "ar");
    };
    
    return (
      <div className="d-flex align-items-center">
        <div 
          className={`language-toggle ${isArabic ? 'arabic' : 'english'}`}
          onClick={handleToggle}
        >
          <div className={`toggle-button ${isArabic ? 'arabic' : 'english'}`}>
            {!isArabic ? 'En' : 'ع'}
          </div>
        </div>
      </div>
    );
};

export default LanguageToggle;